// removed by extract-text-webpack-plugin
module.exports = {"item":"_2FyjlVQ0p5EO3SEb11smtB","news":"_2QU-PKgmor5TsCIwe9UOuR","topMenuHeading":"_33a8ysQw3gbHMMw3SIrJTp","scrollableNews":"_3j9nq9JKY4Pq8SHd7XKVN3","newsItemIcon":"_2rg-H_PmwB6toKqwhNJy31"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/News/index.css
// module id = 177
// module chunks = 0